/* eslint-disable no-nested-ternary */
import React, {
  useEffect, useState, useRef, Fragment,
} from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  Divider, Select, Button, Input, notification, Popconfirm,
} from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import H3FormInput from '@Uilib/h3FormInput';
import H3Text from '@Uilib/h3Text';
import ResourceActions from '@Actions/production/resourceActions';
import ProductActions from '@Actions/productActions';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import Helpers from '@Apis/helpers';
import Crown from '@Images/crown2.png';
import TenantSelector from '@Components/Common/Selector/TenantSelector';
import './style.scss';
import PRZSelect from '../../../../Common/UI/PRZSelect';

const { Option } = Select;

/**
 *
 */
const ResourceForm = ({
  createResource, createResourceLoading, user, updateResourceLoading, selectedResource,
  callback, updateResource, getResourceGroup, resourcesGroup, createResourceGroup, createResourceGroupLoading, getResourceGroupLoading,
}) => {
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [resourceName, setResourceName] = useState('');
  const [capacity, setCapacity] = useState('');
  const [operationalHrs, setOperationalHrs] = useState('');
  const [timeEfficiency, setTimeEfficiency] = useState('');
  const [resourceGroup, setResourceGroup] = useState(null);
  const [resourceGroupName, setResourceGroupName] = useState('');
  const [status, setStatus] = useState('ONLINE');
  const [resourceType, setResourceType] = useState('Machine');
  const [selectedTenant, setSelectedTenant] = useState('');
  const [newResourceGroupName, setNewResourceGroupName] = useState('');
  const inputRef = useRef(null);
  const onNewResourceGroupName = (event) => {
    setNewResourceGroupName(event.target.value);
  };

  const factorySetup = user?.tenant_info?.production_config?.addons?.factory_setup?.is_active;

  useEffect(() => {
    getResourceGroup(user?.tenant_info?.org_id);
    if (selectedResource) {
      // getResource(user?.tenant_info?.org_id, '', '', '', selectedResource?.tenant_id, '', '', true);
      setResourceName(selectedResource?.resource_name);
      setCapacity(selectedResource?.capacity_per_hour);
      setResourceGroup(selectedResource?.resource_group_id);
      setResourceType(selectedResource?.type);
      setStatus(selectedResource?.status);
      setOperationalHrs(selectedResource?.ideal_op_time_hrs_per_day);
      setSelectedTenant(selectedResource?.tenant_id);
      setTimeEfficiency(selectedResource?.ideal_time_efficiency * 100);
    } else {
      setSelectedTenant(user?.tenant_info?.tenant_id);
    }
  }, []);

  const statusArray = [
    { id: 1, statusName: 'Online', statusValue: 'ONLINE' },
    { id: 2, statusName: 'Break Down', statusValue: 'BREAKDOWN' },
    { id: 3, statusName: 'Offline', statusValue: 'OFFLINE' },
  ];

  const isDataValid = () => {
    let isValid = true;
    if (!resourceName || !resourceType || !status || (resourceType === 'Machine' ? (capacity <= 0 || operationalHrs <= 0 || operationalHrs > 24 || timeEfficiency <= 0 || timeEfficiency > 100) : false)) {
      isValid = false;
    }
    return isValid;
  };

  const addResource = () => {
    setFormSubmitted(true);
    if (isDataValid()) {
      if (selectedResource) {
        const payload = {
          org_id: user?.tenant_info?.org_id,
          resource_id: selectedResource?.resource_id,
          resource_name: resourceName,
          status,
          capacity_per_hour: capacity || 0,
          type: resourceType,
          resource_group_id: resourceGroup || null,
          ideal_op_time_hrs_per_day: operationalHrs || 0,
          ideal_time_efficiency: timeEfficiency / 100 || 0,
        };
        updateResource(payload, () => {
          callback();
        });
      } else {
        const payload = {
          org_id: user?.tenant_info?.org_id,
          tenant_id: selectedTenant,
          resource_name: resourceName,
          status,
          capacity_per_hour: capacity || 0,
          type: resourceType,
          resource_group_id: resourceGroup || null,
          ideal_op_time_hrs_per_day: operationalHrs || 0,
          ideal_time_efficiency: timeEfficiency / 100 || 0,
        };
        createResource(payload, () => {
          callback();
        });
      }
    }
  };

  return (
    <Fragment>
      <div className="resources-create__wrapper" style={{ marginBottom: '40px' }}>
        <div className="ant-row">
          <div className="ant-col-md-24 ant-col-xs-24">
            <div className="orgFormLabel">Business Unit</div>
            <TenantSelector
              selectedTenant={selectedTenant}
              showSearch
              onChange={(value) => {
                setSelectedTenant(value);
                setResourceGroup('');
              }}
              placeholder="Select Business Unit"
              labelClassName="orgFormLabel"
              containerClassName="orgInputContainer"
              customStyle={{
                borderRadius: '4px',
                width: '100%',
                fontSize: '13px',
                paddingTop: '0px',
                marginBottom: '0px',
                paddingLeft: '-4px',
              }}
              hideTitle
              noDropdownAlign
              includedTenants={Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.FACTORY_SETUP, Helpers.permissionTypes.READ)}
            />
          </div>
          <div className="ant-col-md-24 ant-col-xs-24">
            <H3FormInput
              name="title"
              type="text"
              containerClassName="orgInputContainer"
              labelClassName="orgFormLabel"
              inputClassName="orgFormInput"
              placeholder=""
              onChange={(event) => setResourceName(event.target.value)}
              value={resourceName}
              disabled={createResourceLoading || updateResourceLoading}
              label="Resource Name"
              maxlength="100"
              required
              showError={formSubmitted && !resourceName}
            />
          </div>

          {/* <div className="ant-col-md-24 ant-col-xs-24"> */}
          {/*  <div className="orgInputContainer"> */}
          {/*    <div className="orgFormLabel"> */}
          {/*      Resource Type */}
          {/*      {' '} */}
          {/*      <span style={{ color: 'red' }}>*</span> */}
          {/*    </div> */}
          {/*    <div className="resources-create__type-section"> */}
          {/*      <Radio.Group */}
          {/*        buttonStyle="solid" */}
          {/*        onChange={(event) => { */}
          {/*          setResourceType(event.target.value); */}
          {/*          setResourceGroup(''); */}
          {/*        }} */}
          {/*        value={resourceType} */}
          {/*      > */}
          {/*        <Radio.Button value="Machine"> */}
          {/*          <FontAwesomeIcon icon={faIndustry} /> */}
          {/*          <H3Text text="Machine" /> */}
          {/*        </Radio.Button> */}
          {/*        <Radio.Button value="Equipment"> */}
          {/*          <FontAwesomeIcon icon={faWrench} /> */}
          {/*          <H3Text text="Equipment" /> */}
          {/*        </Radio.Button> */}
          {/*        /!*<Radio.Button value="Other">*!/ */}
          {/*        /!*  <FontAwesomeIcon icon={faBolt} />*!/ */}
          {/*        /!*  <H3Text text="Other" />*!/ */}
          {/*        /!*</Radio.Button>*!/ */}
          {/*      </Radio.Group> */}
          {/*    </div> */}
          {/*  </div> */}
          {/* </div> */}

          <div className="ant-col-md-24 ant-col-xs-24">
            <div className="orgInputContainer">
              <H3Text text="Work Center" className="orgFormLabel" required />
              <div>
                <PRZSelect
                  value={resourceGroup}
                  getPopupContainer={(triggerNode) => triggerNode.parentNode}
                  filterOption={false}
                  disabled={createResourceLoading || updateResourceLoading || !resourceType}
                  onChange={(value) => {
                    setResourceGroup(value);
                  }}
                  loading={getResourceGroupLoading}
                  dropdownRender={(menu) => (
                    <React.Fragment>
                      {menu}
                      <Divider style={{ margin: '8px 0' }} />
                      <div className="add__resource-group">
                        <Input
                          placeholder="Resource group name.."
                          ref={inputRef}
                          value={newResourceGroupName}
                          onChange={onNewResourceGroupName}
                          onKeyDown={(e) => e.stopPropagation()}
                          disabled={createResourceGroupLoading || getResourceGroupLoading}
                        />
                        <Button
                          type="text"
                          icon={<PlusOutlined />}
                          onClick={() => {
                            if (resourcesGroup?.data?.map((item) => item?.resource_group_name?.toLowerCase())?.includes(newResourceGroupName?.toLowerCase())) {
                              notification.open({
                                type: 'warning',
                                message: 'This resource group is already created',
                                duration: 4,
                                placement: 'top',
                              });
                            } else if (!resourcesGroup?.data?.map((item) => item?.resource_group_name?.toLowerCase())?.includes(newResourceGroupName?.toLowerCase())
                              && !getResourceGroupLoading && newResourceGroupName) {
                              const resourceGroupPayload = {
                                resource_group_type: resourceType?.toUpperCase(),
                                org_id: user?.tenant_info?.org_id,
                                resource_group_name: newResourceGroupName,
                              };
                              createResourceGroup(resourceGroupPayload, (createdResourceGroup) => {
                                getResourceGroup(user?.tenant_info?.org_id);
                                setNewResourceGroupName('');
                                setResourceGroup(createdResourceGroup?.resource_group_id);
                              });
                            }
                          }}
                          loading={createResourceGroupLoading || getResourceGroupLoading}
                          disabled={createResourceGroupLoading || getResourceGroupLoading}
                        >
                          Add item
                        </Button>
                      </div>
                    </React.Fragment>
                  )}
                  onSearch={(value) => setResourceGroupName(value)}
                  // onKeyDown={handleKeyDown}
                  showSearch
                  placeholder="Select a resource group"
                  allowClear
                >
                  {resourcesGroup && resourcesGroup?.data
                    ?.filter((item) => (resourceType ? item?.resource_group_type === resourceType?.toUpperCase() : true))
                    .map((item) => (
                      <Option key={item.resource_group_id} value={item.resource_group_id}>
                        {item?.resource_group_name}
                      </Option>
                    ))}
                </PRZSelect>
              </div>
            </div>
          </div>

          {resourceType === 'Machine' && (
            <div className="ant-col-md-24 ant-col-xs-24">
              <H3FormInput
                name="capacity per hour"
                type="number"
                containerClassName="orgInputContainer"
                labelClassName="orgFormLabel"
                inputClassName="orgFormInput"
                placeholder=""
                onChange={(event) => setCapacity(event.target.value)}
                value={capacity}
                disabled={createResourceLoading || updateResourceLoading}
                label="Capacity Per Hour"
                maxlength="100"
                required={resourceType === 'Machine'}
                showError={formSubmitted && (resourceType === 'Machine' && capacity <= 0)}
              />
            </div>
          )}

          {resourceType === 'Machine' && (
            <div className="ant-col-md-24 ant-col-xs-24">
              <H3FormInput
                name="machine operational hrs"
                type="number"
                containerClassName="orgInputContainer"
                labelClassName="orgFormLabel"
                inputClassName="orgFormInput"
                placeholder=""
                onChange={(event) => setOperationalHrs(event.target.value)}
                value={operationalHrs}
                disabled={createResourceLoading || updateResourceLoading}
                label="Operational Hour Per Day"
                maxlength="100"
                required={resourceType === 'Machine'}
                showError={formSubmitted && (resourceType === 'Machine' && (operationalHrs <= 0 || operationalHrs > 24))}
              />
            </div>
          )}

          {resourceType === 'Machine' && (
            <div className="ant-col-md-24 ant-col-xs-24">
              <H3FormInput
                name="time efficiency"
                type="number"
                containerClassName="orgInputContainer"
                labelClassName="orgFormLabel"
                inputClassName="orgFormInput"
                placeholder=""
                onChange={(event) => setTimeEfficiency(event.target.value)}
                value={timeEfficiency}
                disabled={createResourceLoading || updateResourceLoading}
                label="Ideal Time Efficiency(%)"
                maxlength="100"
                required={resourceType === 'Machine'}
                showError={formSubmitted && (resourceType === 'Machine' && (timeEfficiency <= 0 || timeEfficiency > 100))}
              />
            </div>
          )}
          {/* <div className="resource-create__warning">
            <Alert description="Alternate resources are used when this resource is busy or is under breakdown state." type="info" showIcon />
          </div> */}
          {resourceType === 'Machine' && (
            <div className="ant-col-md-24 ant-col-xs-24">
              <div className="orgInputContainer">
                <div className="orgFormLabel">
                  Status
                  <span style={{ color: 'red' }}>*</span>
                </div>
                <div>
                  <PRZSelect
                    value={status}
                    filterOption={false}
                    disabled={createResourceLoading || updateResourceLoading}
                    onChange={(value) => {
                      setStatus(value);
                    }}
                    showSearch
                    placeholder="Select status"
                    required
                    showError={formSubmitted && !status}
                    errorName="*Please select status"
                    errorClassName="input-error"
                  >
                    {statusArray
                      .map((item) => (

                        <Option key={item.id} value={item.statusValue}>
                          {item?.statusName}
                        </Option>
                      ))}
                  </PRZSelect>
                </div>
              </div>
            </div>
          )}

          <div className="custom-drawer__footer">
            <div className="ant-col-md-6" style={{ marginTop: '0.5rem' }}>
              <div className="indent-barcode__wrapper" style={{ display: 'flex' }}>

                <H3Button
                  buttonType={defaultButtonTypes.BLUE_ROUNDED}
                  text={selectedResource ? 'Update Resource' : 'Create Machine'}
                  onClick={() => addResource()}
                  isLoading={createResourceLoading || updateResourceLoading}
                  disabled={createResourceLoading || updateResourceLoading || createResourceGroupLoading || !factorySetup}
                  style={{
                    width: '160px',
                    borderRadius: '5px',
                    padding: '7px 0px',
                    marginLeft: '0',
                  }}
                />
                {!factorySetup && (
                  <Popconfirm
                    placement="topRight"
                    title="This feature is not accessible within your current plan to use this feature contact us."
                    onConfirm={() => window.Intercom('showNewMessage')}
                    okText="Contact Us"
                    cancelText="Cancel"
                  >
                    <img
                      className="barcode-restrict"
                      src={Crown}
                      alt="premium"
                      style={{
                        marginLeft: '8px',
                        marginTop: '5px',
                      }}
                    />
                  </Popconfirm>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

const mapStateToProps = ({
  UserReducers, ResourceReducers, ProductReducers,
}) => ({
  user: UserReducers.user,
  createResourceLoading: ResourceReducers.createResourceLoading,
  updateResourceLoading: ResourceReducers.updateResourceLoading,
  resources: ResourceReducers.resources,
  resourcesGroup: ResourceReducers.resourcesGroup,
  getResourceGroupLoading: ResourceReducers.getResourceGroupLoading,
  createResourceGroupLoading: ResourceReducers.createResourceGroupLoading,
  products: ProductReducers.products,
});

const mapDispatchToProps = (dispatch) => ({
  createResource: (payload, callback) => dispatch(ResourceActions.createResource(payload, callback)),
  createResourceGroup: (payload, callback) => dispatch(ResourceActions.createResourceGroup(payload, callback)),
  updateResource: (payload, callback) => dispatch(ResourceActions.updateResource(payload, callback)),
  getResource: (orgId, page, limit, searchKeyword, tenantIds, resourceType, resourceStatus, isDropdown) => dispatch(ResourceActions.getResource(orgId, page, limit, searchKeyword, tenantIds, resourceType, resourceStatus, isDropdown)),
  getResourceGroup: (orgId) => dispatch(ResourceActions.getResourceGroup(orgId)),
  getProducts: (keyword, tenantId, stockStatus, limit, page, tenantDepartmentId, excludeOutOfStock, productType, category, isSalesProduct, isPurchaseProduct) => dispatch(ProductActions.getProducts(keyword, tenantId, stockStatus, limit, page, tenantDepartmentId, excludeOutOfStock, productType, category, isSalesProduct, isPurchaseProduct)),

});

ResourceForm.propTypes = {
  user: PropTypes.any,
  getResource: PropTypes.func,
  getResourceGroup: PropTypes.func,
  createResourceGroup: PropTypes.func,
  createResourceGroupLoading: PropTypes.bool,
  resourcesGroup: PropTypes.any,
  resources: PropTypes.any,
  products: PropTypes.any,
  createResourceLoading: PropTypes.bool,
  updateResourceLoading: PropTypes.bool,
  // history: PropTypes.func,
  callback: PropTypes.func,
  createResource: PropTypes.func,
  selectedResource: PropTypes.any,
  updateResource: PropTypes.any,
  getResourceGroupLoading: PropTypes.bool,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ResourceForm));
